<template>
  <div id="app">
    <router-view/>
    <!--<div class="box"></div>-->
    <!--<van-button type="primary">主要按钮</van-button>-->
    <!--<van-button type="info">信息按钮</van-button>-->
    <!--<van-button type="default">默认按钮</van-button>-->
    <!--<van-button type="warning">警告按钮</van-button>-->
    <!--<van-button type="danger">危险按钮</van-button>-->
    <!--<hr>-->
    <!--<van-switch v-model="checked"/>-->
    <!--<hr>-->
    <!--<van-rate v-model="value"/>-->
  </div>
</template>

<script>

export default {
  data () {
    return {
      // checked: true,
      // value: 3
    }
  }
}
</script>

<style lang="less">
//.box {
//  width: 300px; /* (300 / 375) * 100 = 80vw */
//  height: 300px;
//  background-color: pink;
//}
</style>
